import { render, staticRenderFns } from "./TeflTableCountries.vue?vue&type=template&id=3f8c74c3&scoped=true&comments=true&"
import script from "./TeflTableCountries.vue?vue&type=script&lang=js&"
export * from "./TeflTableCountries.vue?vue&type=script&lang=js&"
import style0 from "./TeflTableCountries.vue?vue&type=style&index=0&id=3f8c74c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8c74c3",
  null
  
)

export default component.exports